import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'issue-view-sentiment.none',
		defaultMessage: 'None',
		description: 'In case sentiment field value is null.',
	},
});
